// extracted by mini-css-extract-plugin
module.exports = {"right-arrow-container":"rightArrow_right-arrow-container__1z2Mv"};